import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import Joi from 'joi-full';
import { lifecycle } from 'recompose';

import { syncValidateData } from '../../../common/validator';
import GiftCardForm from '../components/GiftCardForm';
import { FORM } from '../constants';
import { t } from '../../../../modules/infra/i18n';
import { addGiftCard } from '../../order/actions';
import { getActiveBarberId, getIsRentalBarber, getIsRentalShop, getShop } from '../../../auth/selectors';
import { fetchGiftCardByCode } from '../actions';
import { getSelectedGiftCards } from '../../order/selectors';

const schema = Joi.object().keys({
  amount: Joi.number().min(1).required(),
  code: Joi.string().min(6).max(12).optional(),
  barberId: Joi.when('$isRentalShop', {
    is: Joi.boolean().valid(true).required(),
    then: Joi.string().required(),
    otherwise: Joi.string().optional().allow(null),
  }),
});

const validate = (values, props) => syncValidateData(
  values,
  schema,
  { context: { isRentalShop: props.isRentalShop } },
);

const asyncValidate = async (values, dispatch, props) => {
  if (!values.code) return;

  if (props.giftCards.find(item => item.code === values.code)) {
    throw { // eslint-disable-line no-throw-literal
      code: t('register:gift_cards.form.error_code_already_in_sale'),
    };
  }

  const giftCard = await fetchGiftCardByCode(props.shopId, values.code);
  if (giftCard && !giftCard.deletedAt) {
    throw { // eslint-disable-line no-throw-literal
      code: t('register:gift_cards.form.error_code_already_exists'),
    };
  }
};

const form = reduxForm({
  form: FORM,
  validate,
  asyncValidate,
  asyncChangeFields: ['code'],
});

const GiftCardFormContainer = compose(
  connect(
    state => ({
      shopId: getShop(state),
      giftCards: getSelectedGiftCards(state),
      isRentalShop: getIsRentalShop(state),
      isRentalBarber: getIsRentalBarber(state),
      activeBarberId: getActiveBarberId(state),
    }),
    { charge: addGiftCard }
  ),
  form,
  lifecycle({
    componentDidMount() {
      // preselect barber when viewed by rental barbers
      if (this.props.isRentalBarber) {
        this.props.change('barberId', this.props.activeBarberId);
      }
    },
  }),
)(GiftCardForm);

export default GiftCardFormContainer;
